import { render, staticRenderFns } from "./SkeletonMainBanner.vue?vue&type=template&id=2addf143&"
import script from "./SkeletonMainBanner.vue?vue&type=script&lang=js&"
export * from "./SkeletonMainBanner.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonMainBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports